import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CustomPagination from "../../cm_shared/CMCustomPagination";

const customStyles = {
  table: {
    style: {
      // border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      // backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};
let baseUrl = "data:image/png;base64,";
const parseJSONString = (str) => {
  try {
    return JSON.parse(str.replace(/'/g, '"'));
  } catch (error) {
    return str;
  }
};
const SelectedScenarioGroupDetails = (props) => {
  console.log("prop", props);
  const [loading, setLoading] = useState(false);
  const [versionData, setVersionData] = useState([]);
  const rowsPerPageSessionBased = [
    10, 20, 50
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  const columns = [
    {
      name: "Scenario Name",
      selector: "scenario_name",
      sortable: true,
      reorder: true,
      grow: 3,
    },

    {
      name: "Scenario UUID",
      selector: "scenario_uuid",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>{row.scenario_uuid}</div>
      ),
      grow: 3,
    },
    {
      name: "Group ID",
      selector: "scenario_group_id",
      sortable: true,
      reorder: true,
    },
  ];
  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const fetchSelectedScenarioGroupDetails = async () => {
    setLoading(true);
    const response = await axios.post(
      `/cm_get_scenario_details_from_scenario_groups?scenarioId=${props.data.scenario_group_id}`,
      {
        scenarioId: props.data.scenario_group_id,
        page_number_record: page,
        page_size_record: eventsPerPage,
      }
    );

    setVersionData(response.data.data);
    setTotal(response.data.total_records);
    setLoading(false);
  };

  useEffect(() => {
    fetchSelectedScenarioGroupDetails();
  }, [eventsPerPage, page]);
  console.log("PROPS IN VERSIONS", props);
  return (
    <div
      style={{
        margin: "50px",
        border: "solid 1px rgba(0,0,0,.5)",
        borderRadius: "10px",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <CustomPagination
          total={total}
          rowsPerPageOptions={rowsPerPageSessionBased}
          eventsPerPage={eventsPerPage}
          page={page}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onPageChange={handlePageChange}
        />
      </div>
      {loading === false ? (
        <DataTable
          columns={columns}
          data={versionData}
          noDataComponent={"No Versions for the current scenario"}
          progressPending={loading}
          customStyles={customStyles}
          dense
        ></DataTable>
      ) : null}
    </div>
  );
};

export default SelectedScenarioGroupDetails;
